import Promise from 'promise-polyfill';

const state = {
	email: null,
	resetToken: null,
	redirect: null,
	infoMessage: null,
	forgotPasswordError: {
		title: '',
		description: '',
	},
	resetInfo: null,
};

const getters = {
	getResetToken(state) {
		return state.resetToken;
	},

	getEmail(state) {
		return state.email;
	},

	getRedirect(state) {
		return state.redirect;
	},

	getInfoMessage(state) {
		return state.infoMessage;
	},

	getForgotPasswordError(state) {
		return state.forgotPasswordError;
	},

	getResetInfo(state) {
		return state.resetInfo;
	},
};

const mutations = {
	setResetToken(state, token) {
		state.resetToken = token;
	},

	setEmail(state, email) {
		state.email = email;
	},

	invalidate(state, property) {
		state[property] = null;
	},

	setProperty(state, property) {
		if (Object.prototype.hasOwnProperty.call(state, Object.keys(property)[0])) {
			state[Object.keys(property)[0]] = Object.values(property)[0];
			return true;
		}
		return false;
	},
};

const actions = {
	SET_RESET_TOKEN_AND_EMAIL(context, data) {
		return new Promise((resolve, reject) => {
			// Maybe some validation of the token ??
			if (!data.resetToken || !data.email) {
				reject(new Error('Token is invalid or expired')); // TODO
			} else {
				context.commit('setResetToken', data.resetToken);
				context.commit('setEmail', data.email);
				resolve();
			}
		});
	},

	INVALIDATE_PROPERTY(context, property) {
		return new Promise((resolve) => {
			context.commit('invalidate', property);
			resolve();
		});
	},

	SET_PROPERTY(context, property) {
		return new Promise((resolve) => {
			context.commit('setProperty', property);
			resolve();
		});
	},

	LOGOUT_MESSAGE(context, content) {
		return new Promise((resolve) => {
			context.dispatch('SET_PROPERTY', { infoMessage: content })
				.then(() => {
					resolve();
				});
		});
	},
};

export default ({
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
});
